import { Selector } from '@ngxs/store';

import { News, NewsTag } from '../../models';
import { NewsState, NewsStateModel } from '../states/news.state';

export class NewsSelectors {
  @Selector([NewsState])
  static news(state: NewsStateModel): News[] {
    return state ? state.list : [];
  }

  @Selector([NewsState])
  static activeNews(state: NewsStateModel) {
    let filter = state.list;
    if (state.filters.type === 1) {
      filter = state.list.filter(news => news.isNews);
    } else if (state.filters.type === 2) {
      filter = state.list.filter(news => !news.isNews);
    }
    return filter;
  }

  @Selector([NewsState])
  static tagsNews(state: NewsStateModel): NewsTag[] {
    let filter = state ? state.tags : [];
    if (state.filters.type === 1) {
      filter = state.tags.filter(news => news.isNews);
    } else if (state.filters.type === 2) {
      filter = state.tags.filter(news => !news.isNews);
    }
    return filter;
  }

  @Selector([NewsState])
  static searchedText(state: NewsStateModel): string | null {
    return state.filters.searchText;
  }

  @Selector([NewsState])
  static selectedTags(state: NewsStateModel) {
    return state.filters.tags;
  }

  @Selector([NewsState])
  static selectedTab(state: NewsStateModel) {
    return state.filters.type;
  }
}
